import { Component, OnInit } from '@angular/core';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'text-ponto-referencia',
  templateUrl: './text-ponto-referencia.component.html',
  styleUrls: ['./text-ponto-referencia.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class TextPontoReferenciaComponent implements OnInit {
  
  constructor() {}

  ngOnInit() {}

}
